import { IsiGridView } from "./IsiGridView";
import { IIsiDtoGridViewClientState, IsiDtoGridViewSelectedRowClientState, IsiDtoGridViewClientState } from "../../../../Dtos/Isilog.IsiFramework.IsiDataTransferObject.IsiGridView";
import { IIsiGridViewContext } from "./IIsiGridViewContext";
import { IIsiComponentManager } from "../../Core/Manager/IIsiComponentManager";

/**
 * Contexte d'une GridView
 **/
export class IsiGridViewContextBase {
    private _component: IsiGridView;
    //private _gridViewId: string
    private _state: IIsiDtoGridViewClientState;
    private _cellClicked: (cellId: string, button) => Promise<boolean>;
    private _cellDoubleClicked: (cellId: string) => Promise<boolean>;

    private _selectAllId: string;

    constructor(componentManager: IIsiComponentManager, gridViewId: string, state: IsiDtoGridViewClientState) {
        //this._gridViewId = gridViewId;
        this._state = state;
        componentManager.whenComponentFound(gridViewId, (gridView: IsiGridView) => {
            this._component = gridView;

            gridView.addStateLoading((gridView: IsiGridView) => {
                gridView.loadState(state);
            });

            //gridView.addSelectedRowsChanged((sender, args) => {
            //    if (args.added) {
            //        let row = IsiDtoGridViewSelectedRowClientState.fromJS({ key: args.added.key, datas: args.added.datas });
            //        state.selectedRows.rows.push(row);
            //    } else if (args.removed) {
            //        state.selectedRows.rows = state.selectedRows.rows.filter(r => r.key != args.removed.key)
            //    }

            //});
        })
    }

    //get state() {
    //    return this._state;
    //}

    get id() {
        return this._state.id;
    }

    get gridViewId() {
        return this._state.gridViewId;
    }

    get selectAllId() {
        return this._selectAllId;
    }

    get allLinesSelected() {
        return this._component.allLinesSelected;
    }

    set allLinesSelected(value) {
        this._component.allLinesSelected = value;
    }

    get selectedRows() {
        return this._component.selectedRows;
    }

    /** Indique si la grille a des lignes */
    get hasRows() {
        return this._component.hasRows();
    }

    get cellDoubleClicked() {
        return this._cellDoubleClicked;
    }

    set cellDoubleClicked(value: (cellId: string) => Promise<boolean>) {
        this._cellDoubleClicked = value;
    }

    get cellClicked() {
        return this._cellClicked;
    }

    set cellClicked(value) {
        this._cellClicked = value;
    }

    get gridViewMode() {
        return this._component?.getDto()?.gridViewMode;
    }

    /**
     * Permet de déselectionner toutes les lignes
     * */
    clearSelectedRows() {
        if (this._component?.isLoaded()) {
            this._component.clearSelectedRows();
        }
    }
    /**
     * Selectionne une ligne par sa pk
     * @param pk
     */
    selectRowByPk(pk: string) {
        this._component.selectRowByPk(pk);
    }

    /**
     * Selectionne une ligne en fonction de sa véritable clé primaire.
     * @param ids
     */
    selectRowByRealPK(ids: Map<string, any>) {
        this._component.selectRowByRealPK(ids);
    }

    /**
     * rafraichir la grille
     * */
    refresh() {
        if (this._component && this._component.isLoaded()) {
            this._component.refresh();
        }
    }

    /**
     * Indique s'il existe au moins une ligne sélectionnée
     * @returns
     */
    public hasSelectedRows(): boolean {
        if (!this.selectedRows || !this.selectedRows.rows || this.selectedRows.rows.length <= 0) { return false; }
        return true;
    }

    /**
     * Indique le nombre de ligne sélectionnée
     * @returns
     */
    public selectedRowsCount(): number {
        if (this.hasSelectedRows()) { return this.selectedRows.rows.length; }
        return 0;
    }

    /**
     * Construit un tableau contenant les clés primaires des enregistrements sélectionnés.
     * Chaque enregistrement est représenté par une collection de couples clé/valeur (key/value).
     * key contient le nom de la colonne
     * value la valeur correspondant à cette colonne
     * @returns
     */
    public selectedRowsPks(): Array<Array<{ key: string, value: string }>> {

        if (!this.selectedRows || !this.selectedRows.rows) { return []; }

        const pkArray = new Array<Array<{ key: string, value: string }>>();
        this.selectedRows.rows.forEach((row) => {
            let pk = new Array<{ key: string, value: string }>();
            for (const o in row.realKey) {
                pk.push({
                    key: o,
                    value: row.realKey[o]
                });
            };
            pkArray.push(pk);
        });
        return pkArray;
    }

    /**
     * Construit un tableau contenant les valeurs demandées des enregistrements sélectionnés.
     * Chaque enregistrement est représenté par une collection de couples clé/valeur (key/value).
     * key contient le nom de la colonne
     * value la valeur correspondant à cette colonne
     * @returns
     */
    public selectedRowsFields(fields: Array<string>): Array<Array<{ key: string, value: string }>> {

        if (!this.selectedRows || !this.selectedRows.rows) { return []; }

        const pkArray = new Array<Array<{ key: string, value: string }>>();
        this.selectedRows.rows.forEach((row) => {
            let pk = new Array<{ key: string, value: string }>();
            for (const element of fields) {
                pk.push({
                    key: element,
                    value: row.datas[element]
                });
            };
            pkArray.push(pk);
        });
        return pkArray;
    }

    /**
     * Construit un tableau contenant les clés primaires des enregistrements sélectionnés.
     * Uniquement pour les clés primaires simples (basées sur une seule colonne).
     * Chaque enregistrement est représenté par un nombre.
     * @returns
     */
    public selectedRowsPksAsInt(): Array<number> {
        const pkArray = new Array<number>();
        this.selectedRows.rows.forEach((row) => {
            for (const o in row.realKey) {
                pkArray.push(parseInt(row.realKey[o]));
            };
        });
        return pkArray;
    }

    /**
     * Construit un tableau contenant les clés primaires des enregistrements sélectionnés.
     * Uniquement pour les clés primaires simples (basées sur une seule colonne).
     * Chaque enregistrement est représenté par une chaine.
     * @returns
     */
    public selectedRowsPksAsString(): Array<string> {
        const pkArray = new Array<string>();
        this.selectedRows.rows.forEach((row) => {
            for (const o in row.realKey) {
                pkArray.push(row.realKey[o] + "");
            };
        });
        return pkArray;
    }

    /**
   * Construit un tableau contenant les valeurs d'une colonne des enregistrements sélectionnés.
   * Chaque enregistrement est représenté par une chaine.
   * @returns
   */
    public selectedRowsValuesAsString(field: string): Array<string> {
        const pkArray = new Array<string>();
        this.selectedRows.rows.forEach((row) => {
            pkArray.push(row.datas[field] + "");
        });
        return pkArray;
    }

    /**
     * Indique s'il existe au moins une ligne qui remplit la condition colonne/valeur
     * @param column
     * @param value
     * @returns
     */
    public someRowsHave(column: string, value: any): boolean {
        return this.selectedRows.rows.some(row => row.datas[column] == value);
    }

    /**
     * Indique s'il existe au moins une ligne qui ne remplit pas la condition colonne/valeur
     * @param column
     * @param value
     * @returns
     */
    public someRowsDontHave(column: string, value: any): boolean {
        return this.selectedRows.rows.some(row => row.datas[column] != value);
    }

    /**
    * Indique si toutes les lignes remplissent la condition colonne/valeur
    * @param column
    * @param value
    * @returns
    */
    public everyRowsHave(column: string, value: any): boolean {
        return this.selectedRows.rows.every(row => row.datas[column] == value);
    }

}

export class IsiGridViewContext<TComponent extends IsiGridView> extends IsiGridViewContextBase implements IIsiGridViewContext {
    private _componentInitialized: (grid: TComponent) => void;

    get componentInitialized() {
        return this._componentInitialized;
    }

    set componentInitialized(value) {
        this._componentInitialized = value;
    }
}
